import React from 'react';
import { Box, Button, Flex, Text } from '@fullstory/components';
import { shortNumber } from '@fullstory/util/fmt';
import { PageType } from './types';
import { usePageFlow } from './hooks';
import { FormattedMessage } from 'react-intl';

interface PageTooltipContentProps {
  pageDefId: number;
  name: string;
  visits: number;
  visitsPct: string;
  pageType: PageType;
}

export const PageTooltipContent: React.FC<PageTooltipContentProps> = ({
  pageDefId,
  name,
  visits,
  visitsPct,
  pageType,
}) => {
  const { onWatchSessions, isEdit } = usePageFlow();
  return (
    <Box data-component="PageTooltipContent" width={150}>
      <Box margin={[8, 0, 0, 8]}>
        <Text appearance="bodyMediumBold" color="default-inverse">
          {name}
        </Text>
      </Box>
      <Box margin={[4, 0, 0, 8]}>
        <Flex justifyContent="flex-start">
          <Text appearance="bodySmall" color="default-inverse">
            {visitsPct}
          </Text>
          <Box margin={[0, 4, 0, 4]}>
            <Text appearance="bodySmall" color="default-inverse">
              <FormattedMessage
                defaultMessage="·"
                id="G7uas+"
                description="Used as a separator e.g 10% · 100 views"
              />
            </Text>
          </Box>
          <Text appearance="bodySmall" color="default-inverse">
            {shortNumber(visits)}
          </Text>
        </Flex>
      </Box>
      {!isEdit && (
        <Box margin={[8, 0, 8, 8]}>
          <Flex justifyContent="flex-start" alignItems="center">
            <Button
              size="x-small"
              onClick={() => onWatchSessions(undefined, pageType)}
              variant="fill-primary"
            >
              <FormattedMessage defaultMessage="Watch Sessions" id="4GDhCd" />
            </Button>
          </Flex>
        </Box>
      )}
    </Box>
  );
};
